import React, { Component } from 'react';
import './../../assets/css/App.css';
import maskLoaderImg from './../../assets/images/loader.gif';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import DatePicker from './../../component/datePicker';
import WarehouseViewTypeEnum from './../warehouseStatsPage/WarehouseViewTypeEnum';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Package Check-In Errors By Operator",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    };

    displayStrings = {
        incorrect_tracking_number: "Incorrect Tracking Number",
        incorrect_retailer_name: "Incorrect Retailer Name",
        incorrect_locker_number: "Incorrect Locker Number",
        incorrect_weight: "Incorrect Weight",
        incorrect_dimensions: "Incorrect Dimensions",
        duplicate_package_entry: "Duplicate Package Entry"
    };

    percentFormatter = new Intl.NumberFormat("en", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 });

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.viewType = WarehouseViewTypeEnum.ErrorPackageCheckInsByWorker;
    }

    componentDidMount() {
        Service.event.onPackageStatsError.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }
    // private
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        let searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.fetchWarehouseReports(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

   // private
  /*   _callServiceDownloadFile() {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.downloadCannedAccountReport(searchParams, this.viewType);
    }*/

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    // table actions
    searchButtonAction = () => {
      this.currentPage = 1;
      if(this.createdDateStart && this.createdDateEnd){
        this._callServiceFetch(1);
      }else{
        alert("Please select a date range first.");
      }
    };

    jumpToPage = (e) => {
        e.preventDefault();
        let page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

/*    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };*/

    createTableRowColumns = () => {
        let rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList = this.state.responseTableData.results.flatMap((item, itemIndex) => {
                    let tableStripeClass = (itemIndex + 1) % 2 === 0 ? "even" : "odd";
                    let rowSpan = item.errorPackagesByTypeStatistics.length || 1;
                    let mainRowCells = [
                        <TableRowColumn rowSpan={rowSpan} key={item.accountId + "_name"}>{item.firstName} {item.lastName}</TableRowColumn>,
                        <TableRowColumn rowSpan={rowSpan} className="text-right" key={item.accountId + "_totalPackageNo"}>{item.totalPackageNo}</TableRowColumn>,
                        <TableRowColumn rowSpan={rowSpan} className="text-right" key={item.accountId + "_errorPackageNo"}>{item.errorPackageNo}</TableRowColumn>,
                        <TableRowColumn rowSpan={rowSpan} className="text-right" key={item.accountId + "_errorPackagePercentage"}>{this.percentFormatter.format(item.errorPackagePercentage / 100)}</TableRowColumn>,
                    ];
                    let additionalRows = [];
                    if (item.errorPackagesByTypeStatistics.length === 0) {
                        mainRowCells.push(<TableRowColumn colSpan={3} key={item.accountId + "_emptyColumns"}/>);
                    } else {
                        item.errorPackagesByTypeStatistics.forEach((typeStats, errorTypeIndex) => {
                            let detailCells = [
                                <TableRowColumn key={item.accountId + "_" + typeStats.errorType + "_name"}>{this.displayStrings[typeStats.errorType] || typeStats.errorType}</TableRowColumn>,
                                <TableRowColumn className="text-right" key={item.accountId + "_" + typeStats.errorType + "_errorPackageNo"}>{typeStats.errorPackageNo}</TableRowColumn>,
                                <TableRowColumn className="text-right" key={item.accountId + "_" + typeStats.errorType + "_errorPackagePercentage"}>{this.percentFormatter.format(typeStats.errorPackagePercentage / 100)}</TableRowColumn>,
                            ];
                            if (errorTypeIndex === 0) {
                                mainRowCells.push(...detailCells);
                            } else {
                                additionalRows.push(<tr key={item.accountId + "_" + typeStats.errorType} className={tableStripeClass}>
                                  {detailCells}
                                </tr>);
                            }
                        });
                    }
                    let allRowsForAccount = [
                        <tr key={item.accountId} className={tableStripeClass}>
                          {mainRowCells}
                        </tr>
                    ];
                    allRowsForAccount.push(...additionalRows);
                    return allRowsForAccount;
                });
            }
        } else {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList.push(<tr key="0"><td colSpan="8">{this.state.emptyTableMessage}</td></tr>);
            }
        }
        return rowColumnComponentList;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        /*downloadFileAction = {this.downloadFileAction}*/
                        selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}
                        type = "cannedReport"
                    >
                        <DatePicker
                            fieldId = "errorPackageCheckInStartDate"
                            placeHolderText = "Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "errorPackageCheckInEndDate"
                            placeHolderText = "End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                    </TableSearchHeader>
                   <TableHead>
                       <tr>
                           <TableHeaderColumn>Operator Name</TableHeaderColumn>
                           <TableHeaderColumn>Total Number of Packages</TableHeaderColumn>
                           <TableHeaderColumn>Number of Error Packages</TableHeaderColumn>
                           <TableHeaderColumn>Error Package Percentage</TableHeaderColumn>
                           <TableHeaderColumn>Error Type</TableHeaderColumn>
                           <TableHeaderColumn>Number of Error Packages</TableHeaderColumn>
                           <TableHeaderColumn>Error Package Percentage</TableHeaderColumn>
                       </tr>
                   </TableHead>
                   <TableBody>
                       {this.createTableRowColumns()}
                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        goBackToPage={this.goBackToPage}
                        goForwardToPage={this.goForwardToPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;
